
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/functions/overview",
      function () {
        return require("private-next-pages/events/functions/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/functions/overview"])
      });
    }
  